import { useState } from 'react';
import { testimonials } from '@/mocks/comics';

export default function TestimonialSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const current = testimonials[activeIndex];

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-[32px] bg-foreground-950 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            <div className="lg:col-span-2 relative min-h-[300px] lg:min-h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20young%20woman%20reading%20comics%20on%20sofa%20cozy%20atmosphere%20warm%20lighting%20soft%20colors%20artistic%20illustration%20clean%20simple%20background%20manga%20style%20character%20design&width=800&height=1000&seq=testimonial-avatar-01&orientation=portrait"
                alt="韩漫读者"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
            <div className="lg:col-span-3 flex flex-col justify-center p-8 md:p-12 lg:p-14">
              <div className="text-6xl font-serif text-foreground-300 leading-none mb-6">&ldquo;</div>
              <p className="text-lg md:text-xl text-background-50 leading-relaxed">
                {current.content}
              </p>
              <div className="mt-6">
                <p className="text-sm font-semibold text-background-50">{current.name}</p>
                <p className="text-xs text-foreground-300 mt-1">{current.role}</p>
              </div>

              <div className="flex items-center gap-3 mt-8">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`w-2.5 h-2.5 rounded-full transition-all ${
                      index === activeIndex
                        ? 'bg-accent-500 w-8'
                        : 'bg-foreground-600 hover:bg-foreground-400'
                    }`}
                    aria-label={`评价 ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}